// Category metadata (image + slug). Mirrors backend CANONICAL_CATEGORIES.
// Image mapping is canonical and approved — do not swap without product sign-off.
// Served via backend /api/brand mount so our Cache-Control middleware applies.
// `?v=` bust each time the underlying tile bytes change so browsers re-fetch.
const API = process.env.REACT_APP_BACKEND_URL || "";
const V = "iter13"; // bump on every tile refresh
const tile = (slug) => `${API}/api/brand/categories/${slug}.webp?v=${V}`;
export const CATEGORIES = [
  { name: "Advanced Practice Providers", img: tile("advanced-practice-providers") },
  { name: "Chiropractors", img: tile("chiropractors") },
  { name: "Dentists", img: tile("dentists") },
  { name: "Maternal Health", img: tile("maternal-health") },
  { name: "Mental Health", img: tile("mental-health") },
  { name: "Medical Doctors", img: tile("medical-doctors") },
  { name: "Dance", img: tile("dance") },
  { name: "Fitness", img: tile("fitness") },
  { name: "Veterans", img: tile("veterans") },
  { name: "Seniors", img: tile("seniors") },
  { name: "Food & Nutrition", img: tile("food-nutrition") },
  { name: "Holistic Health", img: tile("holistic-health") },
  { name: "Youth", img: tile("youth") },
  { name: "HIV/AIDS", img: tile("hiv-aids") },
  { name: "Supportive Organizations", img: tile("supportive-organizations") },
  { name: "Faith & Health Ministries", img: tile("faith-health-ministries") },
  { name: "African Organizations", img: tile("african-organizations") },
  { name: "Optometrists", img: tile("optometrists") },
];

export const CATEGORY_IMG = Object.fromEntries(CATEGORIES.map((c) => [c.name, c.img]));

// Hero on home page — served from backend /api/brand mount
export const HERO_IMG = `${API}/api/brand/hero-colorado.jpg`;
